import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Link as ScrollLink } from "react-scroll";
import { translations } from "../translations";
import { Menu, X } from "lucide-react";
import LanguageSwitcherMobile from "./LanguageSwitcherMobile";
import LanguageSwitcherDesktop from "./LanguageSwitcherDesktop";
import { Instagram } from "react-feather";

const Header = () => {
  const location = useLocation();
  const currentLang = location.pathname.split("/")[1] || "fr";
  const t = translations[currentLang];

  const [isProjectsOpen, setIsProjectsOpen] = useState(false);
  const [closeTimeout, setCloseTimeout] = useState(null);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const handleMouseEnter = () => {
    if (closeTimeout) clearTimeout(closeTimeout);
    setIsProjectsOpen(true);
  };

  const handleMouseLeave = () => {
    const timeout = setTimeout(() => {
      setIsProjectsOpen(false);
    }, 200);
    setCloseTimeout(timeout);
  };

  useEffect(() => {
    return () => {
      if (closeTimeout) clearTimeout(closeTimeout);
    };
  }, [closeTimeout]);

  const projectsLinks = [
    { label: t.artificialIntelligence, icon: "icones-4.png", slug: "ai" },
    { label: t.industrialDesign, icon: "icones-3.png", slug: "design" },
    { label: t.graphicDesign, icon: "icones-2.png", slug: "graphic" },
    { label: t.creativeLab, icon: "icones-1.png", slug: "lab" },
  ];

  return (
    <header className="w-full py-4 sm:py-0 relative">

      {/* LOGO CENTRÉ pour Mobile */}
      <div className="flex justify-center items-center">
        <img src="/assets/LOGO-KIM-ANH-ATELIER.png" alt="Logo" className="h-24 mb-3" />
      </div>

      {/* Menu Burger pour Mobile */}
      <div className="sm:hidden flex justify-end absolute top-10 right-5 p-3 bg-light rounded-lg">
        <button
          className="text-dark"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
        >
          {mobileMenuOpen ? <X size={28} /> : <Menu size={28} />}
        </button>
        
      </div>

      {/* Menu déroulant Mobile */}
      <div
        className={`sm:hidden ${mobileMenuOpen ? "block" : "hidden"} bg-light px-4 py-4 mt-2 shadow-lg rounded-lg`}
      >

        <nav className="flex flex-col items-center gap-6">
          <Link to={`/${currentLang}`} className="text-dark hover:text-primary" onClick={() => setMobileMenuOpen(false)}>
            {t.home}
          </Link>

          <div className="relative" onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
            <div className="cursor-pointer text-dark hover:text-primary">{t.projects}</div>

            {isProjectsOpen && (
              <div className="absolute top-full left-0 mt-1 w-60 bg-light border rounded-lg shadow-lg z-10">
                {projectsLinks.map((item, i) => (
                  <ScrollLink
                    key={i}
                    to={item.slug} 
                    className="flex items-center px-4 py-2 text-dark hover:bg-mdlight hover:text-primary"
                    onClick={() => {
                      setIsProjectsOpen(false);
                      setMobileMenuOpen(false);
                    }}
                  >
                    <img src={`/assets/icones/${item.icon}`} alt={`${item.label} icon`} className="w-6 h-6 object-cover mr-2" />
                    {item.label}
                  </ScrollLink>
                ))}
              </div>
            )}
          </div>

          <ScrollLink to={`about`} className="text-dark hover:text-primary" onClick={() => setMobileMenuOpen(false)}>
            {t.about}
          </ScrollLink>
          <ScrollLink to={`contact`} className="text-dark hover:text-primary" onClick={() => setMobileMenuOpen(false)}>
            {t.contact}
          </ScrollLink>
<a
            href="https://www.instagram.com/kimanhatelier/?hl=en"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 text-dark hover:text-primary"
          >
            <Instagram size={24} />
            Instagram
          </a>
          <div>
            <LanguageSwitcherMobile />
          </div>
        </nav>
      </div>

      {/* Desktop Navigation */}
      <nav className="hidden sm:flex justify-between items-center w-full bg-light px-4 sm:px-8 py-3 sm:rounded-full shadow-md">
        <div className="flex items-center gap-6">
          <Link to={`/${currentLang}`} className="text-dark hover:text-primary">
            {t.home}
          </Link>

          <div className="relative" onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
            <div className="cursor-pointer text-dark hover:text-primary">{t.projects}</div>

            {isProjectsOpen && (
              <div className="absolute top-full left-0 mt-1 w-60 bg-light border rounded-lg shadow-lg z-10">
                {projectsLinks.map((item, i) => (
                  <ScrollLink
                    key={i}
                    to={item.slug} 
                    className="flex items-center px-4 py-2 text-dark hover:bg-mdlight hover:text-primary"
                    onClick={() => setIsProjectsOpen(false)}
                  >
                    <img src={`/assets/icones/${item.icon}`} alt={`${item.label} icon`} className="w-6 h-6 object-cover mr-2" />
                    {item.label}
                  </ScrollLink>
                ))}
              </div>
            )}
          </div>
        </div>

        <div className="flex items-center gap-6">
          <ScrollLink to={`about`} className="text-dark hover:text-primary">
            {t.about}
          </ScrollLink>
          <ScrollLink to={`contact`} className="text-dark hover:text-primary">
            {t.contact}
          </ScrollLink>
          <a
            href="https://www.instagram.com/kimanhatelier/?hl=en"
            target="_blank"
            rel="noopener noreferrer"
            className="text-dark hover:text-primary flex items-center py-1 rounded-md border border-transparent transition cursor-pointer"
            aria-label="Instagram"
          >
            <Instagram size={20} className="mr-2" />
            Instagram
          </a>
          <LanguageSwitcherDesktop />
        </div>
      </nav>
    </header>
  );
};

export default Header;
